import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { crc32 } from 'crc';
import * as Crypto from 'crypto';
var IS_DEBUG = false; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment

var Buffer = require('buffer/').Buffer;

export var KeyEntity = /*#__PURE__*/function () {
  function KeyEntity(rawKeyEntity, initialVector, password) {
    _classCallCheck(this, KeyEntity);

    _defineProperty(this, "counter", BigInt(0));

    this.rawKeyEntity = rawKeyEntity;
    this.initialVector = initialVector;

    if (this.rawKeyEntity.byteLength !== KeyEntity.ENCRYPTED_KEY_LENGTH) {
      throw new ContainerFormatError();
    }

    this.salt = this.rawKeyEntity.slice(KeyEntity.SALT_OFFSET, KeyEntity.SALT_OFFSET + KeyEntity.SALT_LENGTH);
    if (IS_DEBUG) console.log("PDKF2 salt: ".concat(this.salt.toString('hex')));
    this.encryptedData = this.rawKeyEntity.slice(KeyEntity.KEY_OFFSET, KeyEntity.ENCRYPTED_KEY_LENGTH);

    if (IS_DEBUG) {
      console.log("Encrypted data: ".concat(this.encryptedData.toString('hex')));
    }

    this.aesKey = Crypto.pbkdf2Sync(password, this.salt, KeyEntity.PBKDF_ITERATIONS_NUMBER, KeyEntity.PBKDF_KEY_LENGTH, KeyEntity.PBKDF_ALGO_DIGEST);

    if (IS_DEBUG) {
      console.log("AES key from PDKF2 algo: ".concat(this.aesKey.toString('hex')));
    }
  }

  _createClass(KeyEntity, [{
    key: "decrypt",
    value: function decrypt() {
      var decipher = Crypto.createDecipheriv(KeyEntity.CIPHER_ALGORITHM, this.aesKey, this.initialVector).setAutoPadding(true); // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

      this.decryptedData = Buffer.concat([decipher.update(this.encryptedData), decipher["final"]()]);

      if (IS_DEBUG) {
        console.log("Decrypted unpadded data: ".concat(this.decryptedData.toString('hex')));
      }

      this.decryptedKey = this.decryptedData.slice(0, KeyEntity.KEY_LENGTH);

      if (IS_DEBUG) {
        console.log("Decrypted key: ".concat(this.decryptedKey.toString('hex')));
      }

      this.decryptedCounter = this.decryptedData.slice(KeyEntity.KEY_LENGTH, KeyEntity.KEY_LENGTH + KeyEntity.COUNTER_LENGTH);
      this.counter = this.decryptedCounter.readBigUInt64BE();

      if (IS_DEBUG) {
        console.log("decryptedCounter ".concat(this.decryptedCounter.toString('hex')));
      }

      var decryptedCrc = this.decryptedData.slice(KeyEntity.KEY_LENGTH + KeyEntity.COUNTER_LENGTH, KeyEntity.KEY_LENGTH + KeyEntity.COUNTER_LENGTH + KeyEntity.CRC_LENGTH);
      if (IS_DEBUG) console.log("Decrypted CRC: ".concat(decryptedCrc.readUInt32BE()));
      var calculatedCrc = crc32( // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
      Buffer.concat([this.decryptedKey, this.decryptedCounter]));
      if (IS_DEBUG) console.log("calculated CRC: ".concat(calculatedCrc));

      if (decryptedCrc.readUInt32BE() !== calculatedCrc) {
        throw new IncorrectContainerPassword();
      }
    }
  }, {
    key: "encrypt",
    value: function encrypt(password) {
      var aesKey = Crypto.pbkdf2Sync(password, this.salt, KeyEntity.PBKDF_ITERATIONS_NUMBER, KeyEntity.PBKDF_KEY_LENGTH, KeyEntity.PBKDF_ALGO_DIGEST);
      var cipher = Crypto.createCipheriv(KeyEntity.CIPHER_ALGORITHM, aesKey, this.initialVector).setAutoPadding(true); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access

      var counterBuffer = Buffer.alloc(16); // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access

      counterBuffer.writeBigUInt64BE(this.counter);
      var countedCrc32 = crc32( // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
      Buffer.concat([this.decryptedKey, counterBuffer])); // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

      var crc32Buffer = Buffer.alloc(4); // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access

      crc32Buffer.writeUInt32BE(countedCrc32); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access

      var encryptionBuffer = Buffer.concat([this.decryptedKey, counterBuffer, crc32Buffer]); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access

      this.encryptedData = Buffer.concat( // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      [cipher.update(encryptionBuffer), cipher["final"]()]);
    }
  }, {
    key: "increaseCounter",
    value: function increaseCounter(add) {
      this.counter += BigInt(add);
    }
  }, {
    key: "getSalt",
    value: function getSalt() {
      return this.salt;
    }
  }, {
    key: "getDecryptedKey",
    value: function getDecryptedKey() {
      return this.decryptedKey;
    }
  }, {
    key: "getEncryptedKeyData",
    value: function getEncryptedKeyData() {
      return this.encryptedData;
    }
  }]);

  return KeyEntity;
}();

_defineProperty(KeyEntity, "ENCRYPTED_KEY_LENGTH", 96);

_defineProperty(KeyEntity, "SALT_OFFSET", 0);

_defineProperty(KeyEntity, "SALT_LENGTH", 32);

_defineProperty(KeyEntity, "KEY_OFFSET", 32);

_defineProperty(KeyEntity, "KEY_LENGTH", 32);

_defineProperty(KeyEntity, "COUNTER_OFFSET", 64);

_defineProperty(KeyEntity, "COUNTER_LENGTH", 16);

_defineProperty(KeyEntity, "CRC_LENGTH", 4);

_defineProperty(KeyEntity, "PASSWORD_SALT_LENGTH", 8);

_defineProperty(KeyEntity, "CIPHER_ALGORITHM", 'aes-256-cbc');

_defineProperty(KeyEntity, "PBKDF_ITERATIONS_NUMBER", 20000);

_defineProperty(KeyEntity, "PBKDF_KEY_LENGTH", 32);

_defineProperty(KeyEntity, "PBKDF_ALGO_DIGEST", 'sha512');

export var QKeyReader = /*#__PURE__*/function () {
  function QKeyReader(containerJsonString, password, isReEncrypted) {
    _classCallCheck(this, QKeyReader);

    _defineProperty(this, "encryptedKeyList", []);

    _defineProperty(this, "containerData", '');

    _defineProperty(this, "containerName", '');

    _defineProperty(this, "keyCount", 0);

    this.containerJsonString = containerJsonString;
    this.password = password;
    this.isReEncrypted = isReEncrypted;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    var parsedJson = JSON.parse(this.containerJsonString); // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment

    this.containerData = parsedJson.quantum_key_container; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment

    this.containerName = parsedJson.name; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment

    this.clientNumber = parsedJson.client; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment

    this.keyNumber = parsedJson.number;
    this.parseContainerData();
  }

  _createClass(QKeyReader, [{
    key: "getClientNumber",
    value: function getClientNumber() {
      return this.clientNumber;
    }
  }, {
    key: "getKeyNumber",
    value: function getKeyNumber() {
      return this.keyNumber;
    }
  }, {
    key: "parseContainerData",
    value: function parseContainerData() {
      var separatedContainerData = this.containerData.split('\n');

      if (separatedContainerData.length !== 3) {
        throw new ContainerFormatError();
      }

      var base64ContainerContent = separatedContainerData[1]; // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

      this.containerBuffer = Buffer.from(base64ContainerContent, 'base64');

      if (IS_DEBUG) {
        console.log("Container binary buffer ".concat(this.containerBuffer.toString('hex')));
      }

      this.initialVector = this.containerBuffer.slice(QKeyReader.INITIAL_VECTOR_OFFSET, QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH);

      if (IS_DEBUG) {
        console.log("Initial vector: ".concat(this.initialVector.toString('hex')));
      }

      if ((this.containerBuffer.byteLength - this.initialVector.byteLength) % KeyEntity.ENCRYPTED_KEY_LENGTH !== 0) {
        throw new ContainerFormatError();
      }

      this.keyCount = (this.containerBuffer.byteLength - this.initialVector.byteLength) / KeyEntity.ENCRYPTED_KEY_LENGTH;

      if (this.keyCount <= 0) {
        throw new ContainerFormatError();
      }

      for (var index = 0; index < this.keyCount; index++) {
        if (IS_DEBUG) {
          console.log("Key group #".concat(index + 1, ": ").concat(this.containerBuffer.slice(QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH + index * KeyEntity.ENCRYPTED_KEY_LENGTH, QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH + (index + 1) * KeyEntity.ENCRYPTED_KEY_LENGTH).toString('hex')));
        }

        var encryptedKey = new KeyEntity(this.containerBuffer.slice(QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH + index * KeyEntity.ENCRYPTED_KEY_LENGTH, QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH + (index + 1) * KeyEntity.ENCRYPTED_KEY_LENGTH), this.initialVector, this.password);
        encryptedKey.decrypt();
        this.encryptedKeyList.push(encryptedKey);
      }
    }
  }, {
    key: "getEncryptedKeyList",
    value: function getEncryptedKeyList() {
      return this.encryptedKeyList;
    }
  }, {
    key: "encryptContainer",
    value: function encryptContainer(password) {
      var encryptedContainer = this.initialVector;

      for (var index = 0; index < this.keyCount; index++) {
        this.encryptedKeyList[index].encrypt(password); // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment

        encryptedContainer = Buffer.concat([encryptedContainer, this.encryptedKeyList[index].getSalt(), this.encryptedKeyList[index].getEncryptedKeyData()]);
      }

      var containerLines = this.containerData.split('\n');
      this.containerData = "".concat(containerLines[0], "\n").concat(encryptedContainer.toString('base64'), "\n").concat(containerLines[2]); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

      var parsedJson = JSON.parse(this.containerJsonString); // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

      parsedJson.quantum_key_container = this.containerData;
      this.containerJsonString = JSON.stringify(parsedJson);
      return this.containerJsonString;
    }
  }]);

  return QKeyReader;
}();

_defineProperty(QKeyReader, "INITIAL_VECTOR_OFFSET", 0);

_defineProperty(QKeyReader, "INITIAL_VECTOR_LENGTH", 16);

export var ClientKeyEntity = /*#__PURE__*/function () {
  function ClientKeyEntity(clientKey) {
    _classCallCheck(this, ClientKeyEntity);

    this.clientKey = clientKey;
    this.salt = clientKey.slice(ClientKeyEntity.SALT_OFFSET, ClientKeyEntity.SALT_OFFSET + ClientKeyEntity.SALT_LENGTH);
    this.key = clientKey.slice(ClientKeyEntity.KEY_OFFSET, ClientKeyEntity.KEY_OFFSET + ClientKeyEntity.KEY_LENGTH);
    this.counter = clientKey.slice(ClientKeyEntity.COUNTER_OFFSET, ClientKeyEntity.COUNTER_OFFSET + ClientKeyEntity.COUNTER_LENGTH);
  }

  _createClass(ClientKeyEntity, [{
    key: "getKey",
    value: function getKey() {
      return this.key;
    }
  }, {
    key: "getSalt",
    value: function getSalt() {
      return this.salt;
    }
  }, {
    key: "getCounter",
    value: function getCounter() {
      return this.counter;
    }
  }]);

  return ClientKeyEntity;
}();

_defineProperty(ClientKeyEntity, "CONTAINER_KEY_LENGTH", 80);

_defineProperty(ClientKeyEntity, "SALT_OFFSET", 0);

_defineProperty(ClientKeyEntity, "SALT_LENGTH", 32);

_defineProperty(ClientKeyEntity, "KEY_OFFSET", 32);

_defineProperty(ClientKeyEntity, "KEY_LENGTH", 32);

_defineProperty(ClientKeyEntity, "COUNTER_OFFSET", 64);

_defineProperty(ClientKeyEntity, "COUNTER_LENGTH", 16);

export var QClientToClientKeyReader = /*#__PURE__*/function () {
  function QClientToClientKeyReader(container) {
    _classCallCheck(this, QClientToClientKeyReader);

    _defineProperty(this, "keyList", []);

    _defineProperty(this, "keyCount", 0);

    this.container = container;
    this.parseContainerData();
  }

  _createClass(QClientToClientKeyReader, [{
    key: "parseContainerData",
    value: function parseContainerData() {
      var separatedContainerData = this.container.split('\n');

      if (separatedContainerData.length !== 3) {
        throw new ContainerFormatError();
      }

      var base64ContainerContent = separatedContainerData[1]; // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

      this.containerBuffer = Buffer.from(base64ContainerContent, 'base64');
      this.initialVector = this.containerBuffer.slice(QKeyReader.INITIAL_VECTOR_OFFSET, QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH);

      if ((this.containerBuffer.byteLength - this.initialVector.byteLength) % ClientKeyEntity.CONTAINER_KEY_LENGTH !== 0) {
        throw new ContainerFormatError();
      }

      this.keyCount = (this.containerBuffer.byteLength - this.initialVector.byteLength) / ClientKeyEntity.CONTAINER_KEY_LENGTH;

      if (this.keyCount <= 0) {
        throw new ContainerFormatError();
      }

      for (var index = 0; index < this.keyCount; index++) {
        this.keyList.push(new ClientKeyEntity(this.containerBuffer.slice(QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH + index * ClientKeyEntity.CONTAINER_KEY_LENGTH, QKeyReader.INITIAL_VECTOR_OFFSET + QKeyReader.INITIAL_VECTOR_LENGTH + (index + 1) * ClientKeyEntity.CONTAINER_KEY_LENGTH)));
      }
    }
  }, {
    key: "getKeyList",
    value: function getKeyList() {
      return this.keyList;
    }
  }]);

  return QClientToClientKeyReader;
}();

_defineProperty(QClientToClientKeyReader, "INITIAL_VECTOR_OFFSET", 0);

_defineProperty(QClientToClientKeyReader, "INITIAL_VECTOR_LENGTH", 16);

export var ContainerFormatError = /*#__PURE__*/function (_Error) {
  _inherits(ContainerFormatError, _Error);

  var _super = _createSuper(ContainerFormatError);

  function ContainerFormatError() {
    _classCallCheck(this, ContainerFormatError);

    return _super.apply(this, arguments);
  }

  return _createClass(ContainerFormatError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var IncorrectContainerPassword = /*#__PURE__*/function (_Error2) {
  _inherits(IncorrectContainerPassword, _Error2);

  var _super2 = _createSuper(IncorrectContainerPassword);

  function IncorrectContainerPassword() {
    _classCallCheck(this, IncorrectContainerPassword);

    return _super2.apply(this, arguments);
  }

  return _createClass(IncorrectContainerPassword);
}( /*#__PURE__*/_wrapNativeSuper(Error));